module.exports = __webpack_public_path__ + "static/media/notifLaptop.2c5a32cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/notifLaptop.png
// module id = 98
// module chunks = 0